"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grant = void 0;
const index_1 = require("../index");
const IdentityInfo_1 = __importDefault(require("../IdentityInfo"));
class Grant {
    constructor(type, data) {
        this.identityInfo = IdentityInfo_1.default.genFromList(type, data, [
            "OBJECTID",
            "State",
            "CD_ID",
            null,
            "SLDL_ID",
            "SLDU_ID",
        ]);
        this.City = index_1.parseEsriString(data?.City);
        this.Recipient = index_1.parseEsriString(data?.Recipient);
        this.Project_ID = index_1.parseEsriString(data?.Project_ID);
        this.Year = index_1.parseEsriNumber(data?.Year);
        this.Program = index_1.parseEsriString(data?.Program);
        this.Project_Description = index_1.parseEsriString(data?.Project_Description);
        this.Allocation = index_1.parseEsriNumber(data?.Allocation);
    }
}
exports.Grant = Grant;
